import { nanoid } from 'nanoid';
import React, { useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import Loja from '~/components/Loja';
import { BuscaProduto } from '~/components/NovosInputs';
import { SeparatorNovo } from '~/components/SeparatorNovo';
import { toNumberOrZero } from '~/utils/functions';
import { useAlteracaoNcmLote } from '../../hooks/useAlteracaoNcmLote';

export const FormNcmEmLote: React.FC = () => {
  const {
    formNcmLote,
    handleChangeLojas,
    lojas,
    rows,
    setLoading,
    setRows,
    handleCheckAllProducts,
    loading,
    onResetCampo,
    resetCampo,
    handleFocusBuscaProduto,
  } = useAlteracaoNcmLote();

  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = formNcmLote;

  const handleAddProduto = useCallback(
    (selected: any) => {
      if (!Array.isArray(selected) || selected.length === 0) {
        handleFocusBuscaProduto();
        return;
      }

      const existingCodes = new Set(rows.map((r) => r.cod_produto));
      const hasDuplicate = selected.some((p) =>
        existingCodes.has(p.cod_produto),
      );

      if (hasDuplicate) {
        setLoading({ table: false, submit: false });
        handleFocusBuscaProduto();
        toast.warning('Produto já adicionado na grade');
        return;
      }

      const produtoInsert: any[] = selected
        .filter((i) => i?.cod_ncm != null)
        .map((i) => {
          const codSimilar = toNumberOrZero(i?.cod_similar);
          const hasSimilar = codSimilar > 0;

          return {
            uuid: nanoid(),
            cod_loja: i.cod_loja,
            cod_produto: i.cod_produto,
            des_produto: i.des_produto,
            des_ncm: `${i.cod_ncm ?? ''} | ${i.num_ncm ?? ''} - ${
              i.des_ncm ?? ''
            }`,
            cod_ncm: i.cod_ncm,
            num_ncm: i.num_ncm,
            flg_transferir: false,
            flg_similar: hasSimilar,
            des_similar: hasSimilar
              ? `${codSimilar} - ${i.des_similar ?? ''}`
              : undefined,
            cod_tipo_item: i.cod_tipo_item ?? undefined,
            des_tipo_item: i.des_tipo_item ?? undefined,
          };
        });

      if (produtoInsert.length === 0) {
        setLoading({ table: false, submit: false });
        handleFocusBuscaProduto();
        toast.warning(
          'Nenhum produto válido para adicionar (NCM não informado).',
        );
        return;
      }

      setLoading({ table: true, submit: false });
      setRows((prev) => [...prev, ...produtoInsert]);
      setTimeout(() => {
        setLoading({ table: false, submit: false });
        handleFocusBuscaProduto();
      }, 50);
    },
    [handleFocusBuscaProduto, rows, setLoading, setRows],
  );

  return (
    <>
      <Row>
        <Col sm={12}>
          <Loja
            isMulti
            onChange={(val: number | number[]) => {
              handleChangeLojas(val);
            }}
            disabled={false}
            selectedLoja={lojas}
          />
        </Col>
      </Row>
      <Col sm={12} md={12}>
        <SeparatorNovo leftLabel="Busca Por" marginTop={20} />
      </Col>
      <Row>
        <Col sm={12} md={12} style={{ marginTop: '-15px' }}>
          <BuscaProduto
            placeholder="Busque por Código, GTIN ou Descrição *"
            name="busca_produto"
            register={register}
            isError={!!errors.busca_produto}
            control={control}
            buscaNasLojas={lojas || 1}
            customOptions={{
              buscarPor: [
                'Produto',
                'Fornecedor',
                'Departamento',
                'NCM',
                'Check-List',
                'Similares',
              ],
              showSelecionarItensContendo: true,
              buscaPadrao: 'Produto',
            }}
            setValue={setValue}
            clearCampoBusca={resetCampo}
            getProduct={(selected: any) => {
              handleAddProduto(selected);
              onResetCampo(false);
            }}
            disabled={loading.table || loading.submit}
            id="busca-produto-326"
          />
        </Col>
        <Col sm={12} md={12}>
          <SeparatorNovo
            childrenBorder={false}
            marginTop={25}
            marginBottom={20}
            childrenPosition="right"
            childrenPadding="0rem 0rem"
          >
            <CustomButtonNovo
              ghost
              label="Desmarcar todos"
              width="8.125rem"
              onClick={() => handleCheckAllProducts(false)}
              disabled={rows.length === 0 || loading.table || loading.submit}
            />
            <span style={{ color: '#8850BF' }}>|</span>
            <CustomButtonNovo
              ghost
              label="Marcar todos"
              width="6.875rem"
              onClick={() => handleCheckAllProducts(true)}
              disabled={rows.length === 0 || loading.table || loading.submit}
            />
          </SeparatorNovo>
        </Col>
      </Row>
    </>
  );
};
